import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';
import moment from 'moment';

export class ProfileOrderStore {
    loaderOrders = true;
    loaderOrder = true;
    loaderRepeatOrder = false;
    loaderRequestDocuments = false;
    loaderRequestAct = false;

    orders = null;
    order = null;
    sortedOrders = null;
    ordersStatus = 0;

    showModal = false;
    modalMessage = '';
    selectValue = 'dateDecrease';

    getOrders = () => {
        this.loaderOrders = true;
        Api.fetch(this.ordersStatus === 0 ? 'order' : 'order/history')
            .then(response => {
                this.orders = response.result;
                this.sortedOrders = this.orders.sort((a, b) => moment(b.beginDate).valueOf() - moment(a.beginDate).valueOf());
            })
            .finally(() => {
                this.loaderOrders = false;
            });
    };

    getShortOrdersList = () => {
        this.loaderOrders = true;
        Api.fetch('order/history', { limit: 5 })
            .then(response => {
                this.orders = response.result;
            })
            .finally(() => {
                this.loaderOrders = false;
            });
    };

    getOrder = orderId => {
        this.loaderOrder = true;
        Api.fetch(`order/${orderId}`)
            .then(response => {
                this.order = response.result;
            })
            .finally(() => {
                this.loaderOrder = false;
            });
    };

    repeatOrder = orderId => {
        this.loaderRepeatOrder = true;
        Api.fetch(`order/${orderId}/retry`, { utm: 'utm_lk' }, 'post')
            .then(response => {
                if (response.success) {
                    this.showModal = true;
                    this.modalMessage = response.result.message;
                }
            })
            .finally(() => {
                this.loaderRepeatOrder = false;
            });
    };

    requestDocuments = orderId => {
        this.loaderRequestDocuments = true;
        Api.fetch(`order/${orderId}/documents`, { utm: 'utm_lk' }, 'post')
            .then(response => {
                if (response.success) {
                    this.showModal = true;
                    this.modalMessage = response.result.message;
                }
            })
            .finally(() => {
                this.loaderRequestDocuments = false;
            });
    };

    requestAct = orderId => {
        this.loaderRequestAct = true;
        Api.fetch(`order/${orderId}/act`, { utm: 'utm_lk' }, 'post')
            .then(response => {
                if (response.success) {
                    this.showModal = true;
                    this.modalMessage = response.result.message;
                }
            })
            .finally(() => {
                this.loaderRequestAct = false;
            });
    };

    onUpdateRange = date => {
        this.sortedOrders = this.orders.filter(
            ({ beginDate, closeDate }) =>
                moment(beginDate).isBetween(moment(date[0]), moment(date[1])) ||
                moment(closeDate).isBetween(moment(date[0]), moment(date[1])),
        );
        this.sortOrders();
    };

    onUpdateSearch = e => {
        this.sortedOrders = this.orders.filter(({ id }) => id.includes(e.target.value));
        this.sortOrders();
    };

    onUpdateFilter = e => {
        this.selectValue = e.target.value;
        this.sortOrders();
    };

    sortOrders = () => {
        switch (this.selectValue) {
            case 'priceDecrease': {
                this.sortedOrders = this.sortedOrders.sort((a, b) => +b.opportunity - +a.opportunity);
                break;
            }
            case 'priceIncrease': {
                this.sortedOrders = this.sortedOrders.sort((a, b) => +a.opportunity - +b.opportunity);
                break;
            }
            case 'dateDecrease': {
                this.sortedOrders = this.sortedOrders.sort((a, b) => moment(b.beginDate).valueOf() - moment(a.beginDate).valueOf());
                break;
            }
            case 'dateIncrease': {
                this.sortedOrders = this.sortedOrders.sort((a, b) => moment(a.beginDate).valueOf() - moment(b.beginDate).valueOf());
                break;
            }
            default:
                return this.sortedOrders;
        }
    };

    setOrdersToCurrent = () => {
        this.ordersStatus = 0;
        this.getOrders();
    };
    setOrdersToArchive = () => {
        this.ordersStatus = 1;
        this.getOrders();
    };

    removeOrder = () => {
        this.order = null;
    };

    hideModal = () => (this.showModal = false);
}

decorate(ProfileOrderStore, {
    loaderOrders: observable,
    loaderOrder: observable,
    loaderRepeatOrder: observable,
    loaderRequestDocuments: observable,
    loaderRequestAct: observable,

    orders: observable,
    order: observable,
    sortedOrders: observable,
    ordersStatus: observable,
    selectValue: observable,

    showModal: observable,
    modalMessage: observable,

    getOrders: action,
    getOrder: action,
    setOrdersToCurrent: action,
    setOrdersToArchive: action,
    setSortedOrders: action,
    getShortOrdersList: action,
    repeatOrder: action,
    requestAct: action,
    hideModal: action,
    removeOrder: action,
    onUpdateFilter: action,
    onUpdateRange: action,
    onUpdateSearch: action,
});
